<template>
  <v-dialog
    max-width="800px"
    :value="value"
    @input="e => $emit('input', e)"
  >
    <v-card  v-if="gsa">
      <v-card-title>
        Данные для подключения: {{gsa.comment}}
      </v-card-title>
      <v-card-text>
        <TextField 
          label="GSA-Destination токен"
          disabled
          :loading="loading"
          :value="token"
          :copyvalue="!loading"
        />
        <span v-if="!loading">Передайте этот токен разработчику, и/или вставьте в поле <b>head_server.ident_token</b> в файле конфигурации GSA</span>
        
      </v-card-text>
      <v-card-actions>
        <v-btn
          :loading="loading"
          text
          color="green"
          
          @click="$emit('input', false)"
        >
          <v-icon>mdi-check</v-icon>
          Ок
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="green"
          dark
        >
          <v-icon>mdi-download</v-icon>
          Скачать файл конфигурации для GSA
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TextField from './ui/TextField.vue'

export default {
  props: ['gsa', 'value'],
  data: () => ({
    loading: true,
    token: ''
  }),
  watch:{
    value(val){
      if (val == true){
        this.create_token()
      }
    }
  },
  methods:{
    async create_token(){
      this.loading = true
      this.token = await this.$store.dispatch('create_token', this.gsa.guid)
      this.loading = false
    }
  },
  components:{
    TextField
  }
}
</script>